<template>

  <sub-frame title="邮寄信息">

    <div slot="head">

      <mt-button
        icon="more"
        v-if="actions.length"
        type="primary"
        @click="sheetVisible = !sheetVisible"
      ></mt-button>

    </div>

    <mt-actionsheet :actions="actions" v-model="sheetVisible" />

    <template v-if="!editable">

      <mt-cell title="需要邮寄" :value="mail.deliveryDisabled"></mt-cell>

      <mt-cell title="邮寄份数" :value="mail.pdfCount"></mt-cell>

      <mt-cell title="收件人" :value="mail.name"></mt-cell>

      <mt-cell title="联系电话" :value="mail.phone"></mt-cell>

      <mt-cell title="收件地址" :value="mail.address"></mt-cell>

      <mt-cell title="快递公司" :value="mail.expressCompany"></mt-cell>

      <mt-cell title="快递单号" :value="mail.expressNo"></mt-cell>

    </template>

    <template v-else>

      <mt-cell
        title="需要邮寄"
        :value="mailModified.deliveryDisabled"
      ></mt-cell>

      <mt-cell title="邮寄份数">

        <input type="number" v-model="mailModified.pdfCount" />

      </mt-cell>

      <mt-cell title="收件人">

        <input type="text" v-model="mailModified.name" />

      </mt-cell>

      <mt-cell title="联系电话">

        <input type="number" v-model="mailModified.phone" />

      </mt-cell>

      <mt-cell title="收件地址">

        <input type="text" v-model="mailModified.address" />

      </mt-cell>

      <mt-cell title="快递公司">

        <input type="text" v-model="mailModified.expressCompany" />

      </mt-cell>

      <mt-cell title="快递单号">

        <input type="text" v-model="mailModified.expressNo" />

      </mt-cell>

    </template>

  </sub-frame>

</template>

<script>
import applyMailStatusMap from "@/assets/applyMailStatusMap";
export default {
  name: "ApplyMail",
  data() {
    return {
      applyGuid: this.$route.query.applyGuid,
      sheetVisible: false,
      editable: false,
      actionsAll: [
        {
          name: "编辑修改",
          method: () => (this.editable = true),
        },
        {
          name: "保存修改",
          method: this.saveMailInfo,
        },
      ],
      mail: {
        deliveryDisabled: "",
        pdfCount: "",
        guid: "",
        name: "",
        addressee: "",
        phone: "",
        address: "",
        expressCompany: "",
        expressNo: "",
      },
      mailModified: null,
    };
  },
  computed: {
    actions() {
      if (
        this.$store.state.notaryRights &&
        this.$store.state.notaryRights.mail_modify
      ) {
        return [this.actionsAll[this.editable ? 1 : 0]];
      } else {
        return [];
      }
    },
  },
  created() {
    this.getApplyMailInfo();
  },
  methods: {
    async getApplyMailInfo() {
      let res = await this.$axios.get(`/applycheck/applymail`, {
        params: {
          applyGuid: this.applyGuid,
        },
      });
      let d = res.data;
      this.mail = {
        ...d,
        deliveryDisabled: applyMailStatusMap[d.deliveryDisabled],
      };
      this.mailModified = Object.assign({}, this.mail);
    },
    async saveMailInfo() {
      await this.$axios.post(`/applycheck/applymailmodify`, this.mailModified);
      this.$toast("修改成功");
      this.mail = Object.assign({}, this.mailModified);
      this.editable = false;
    },
  },
};
</script>

<style scoped>

</style>
